export default "__VITE_ASSET__779cd346__"